import React from "react";
import { Link } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import { Box, Button, makeStyles } from "@material-ui/core";
import { fontStyleHeading } from "../../ui/constants";
const useStyles = makeStyles((theme, session) => ({
  sponsorCard: {
    display: "flex",
    borderRadius: theme.spacing(1),
    boxShadow: "1px 1px 6px rgba(0,0,0,.3)",
    borderLeft: "#eee solid 2px",
    margin: "0 15px 20px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: "10px",
    },
    [theme.breakpoints.up("sm")]: {
      margin: "0 15px 20px",
    },
  },
  imageContainer: {
    display: "flex",
    padding: "20px",
  },
  contentContainer: {
    padding: theme.spacing(2),
    height: "100%",
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  btnjoin: {
    width: "100%",
    textAlign: "center",
  },
  title: {
    ...fontStyleHeading,
    [theme.breakpoints.down("sm")]: {
      fontSize: "15px",
    },
  },
  memberBenefits: {
    ...fontStyleHeading,
    fontSize: "20px !important",
    fontfamily: "Segoe UI",
    fontWeight: 700,
    color: "#e00000",
    padding: "10px",
    borderBottom: "1px solid #dcdcdc",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  "@media (max-width: 600px)": {
    sponsorCard: {
      flexDirection: "column",
      width: "95%",
    },
    imageContainer: {
      justifyContent: "center",
    },
  },
}));

const Sponsors = (props) => {
  const { session, sponsors } = props;
  const classes = useStyles();

  const urlRegex = /((https?:\/\/)?(www\.)[^\s]+)/gi;
  const formatLink = (raw) =>
    /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;

  const emailRegex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i;
  const renderContact = (contact) => {
    if (!contact) return null;
    const trimmed = String(contact).trim();
    if (emailRegex.test(trimmed)) {
      return (
        <a
          href={`mailto:${trimmed}`}
          style={{ color: "#E00000", textTransform: "lowercase" }}
        >
          {trimmed}
        </a>
      );
    }
    return trimmed;
  };

  const renderTextWithLinks = (text) => {
    if (!text) return null;
    const parts = [];
    let lastIndex = 0;
    let match;
    while ((match = urlRegex.exec(text)) !== null) {
      const url = match[0];
      const idx = match.index;
      if (idx > lastIndex) parts.push(text.slice(lastIndex, idx));
      const href = formatLink(url);
      parts.push(
        <a
          key={idx}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#E00000", textTransform: "lowercase" }}
        >
          {href}
        </a>
      );
      lastIndex = idx + url.length;
    }
    if (lastIndex < text.length) parts.push(text.slice(lastIndex));
    return parts.map((p, i) =>
      typeof p === "string" ? (
        <span key={i}>{p}</span>
      ) : (
        <React.Fragment key={i}>{p}</React.Fragment>
      )
    );
  };

  return (
    <Box border="1px solid #dcdcdc" className="rightMemberAreaScreen">
      {session && (
        <Box className="fontStyleHeadingProfile" {...(!session && { m: 2 })}>
          {session ? "Member Benefits" : "Sponsors"}
        </Box>
      )}
      <Box
        maxHeight="100%"
        {...(!session && { m: 2 })}
        id={!session && "sponserLogout"}
      >
        <Box className={!session && "sponserIntroSection"}>
          {session ? (
            <Box p={2} className="textStyles">
              <spna style={{ color: "#e00000" }}>Motor Events Racing</spna> is
              proudly supported by a number of national business that share our
              love of budget racing. See are range of deals on offer.
            </Box>
          ) : (
            <Box p={2} className="textStyles">
              <spna style={{ color: "#e00000" }}>Motor Events Racing</spna> is
              proudly supported by a number of national business that share our
              love of budget racing. Please support those companies that support
              our sport! Registered Motor Events Racing Members receive
              exclusive discounts and benefits. Go register your team now and
              join in the fun!
            </Box>
          )}
          {!session && (
            <Box className={classes.btnjoin}>
              <Link to="/events">
                <Button
                  variant="contained"
                  disableElevation
                  style={{
                    backgroundColor: "#E00000",
                    color: "white",
                    marginBottom: "15px",
                    marginTop: "10px",
                  }}
                >
                  Join Event
                </Button>
              </Link>
            </Box>
          )}
        </Box>

        {sponsors?.map((value, index) => {
          const rawLink = value.weblink || "";
          const formattedLink =
            rawLink && !/^https?:\/\//i.test(rawLink)
              ? `https://${rawLink}`
              : rawLink;

          // prepare description rendering: first word in red, rest linkified
          const description = value.description || "";
          let descriptionNode = null;
          if (description) {
            const firstSpace = description.indexOf(" ");
            if (firstSpace === -1) {
              // single word description
              if (urlRegex.test(description)) {
                const href = formatLink(description);
                descriptionNode = (
                  <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "red", textTransform: "lowercase" }}
                  >
                    {href}
                  </a>
                );
              } else {
                descriptionNode = (
                  <span style={{ color: "red" }}>{description}</span>
                );
              }
            } else {
              const first = description.slice(0, firstSpace);
              const rest = description.slice(firstSpace + 1);
              const firstNode = urlRegex.test(first) ? (
                <a
                  href={formatLink(first)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "red", textTransform: "lowercase" }}
                >
                  {formatLink(first)}
                </a>
              ) : (
                <span style={{ color: "red" }}>{first} </span>
              );
              descriptionNode = (
                <>
                  {firstNode}
                  {renderTextWithLinks(rest)}
                </>
              );
            }
          }

          return (
            <Box
              key={index}
              className={`${classes.sponsorCard} ${
                !session && "sponsorLoopWrapper"
              }`}
            >
              <Box className={classes.imageContainer}>
                <Box className="sponserCardImage">
                  <img
                    src={value.image_link}
                    className={"brandimg"}
                    alt="sponsor"
                  />
                </Box>
              </Box>
              {session && (
                <Box
                  m={2}
                  className="sponserDetailborder"
                  border="1px solid #dcdcdc"
                ></Box>
              )}
              <Box className={classes.contentContainer}>
                <Box className="sponserDetailCard">
                  <p className={classes.title}>{value.title}</p>

                  <Box mb={1}>
                    <span className="bold">Web Link: </span>
                    <a
                      style={{ color: "#E00000", textTransform: "lowercase" }}
                      href={formattedLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {formattedLink}
                    </a>
                  </Box>

                  {session && (
                    <Box mb={1}>
                      <span className="bold">Contact: </span>
                      <span
                        style={{ color: "#E00000", textTransform: "lowercase" }}
                      >
                        {renderContact(value.contact)}
                      </span>
                    </Box>
                  )}
                  {session &&
                    value.member_benefits?.map((val, i) => {
                      if (val.description !== "") {
                        return (
                          <ul key={i}>
                            <li className="textStyles">
                              {renderTextWithLinks(val.description)}
                            </li>
                          </ul>
                        );
                      }
                      return null;
                    })}
                  <Box className="textStyles">{descriptionNode}</Box>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

function mapStateToProps(state) {
  const session = state.session;
  const router = state.router;
  return {
    session,
    router,
  };
}

export default connect(mapStateToProps)(Sponsors);
